export function ucFirst(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
export function base64Encode(str) {
    if (typeof btoa === 'undefined') {
        return Buffer.from(str).toString('base64');
    }
    return btoa(str);
}
export function base64Decode(str) {
    if (typeof atob === 'undefined') {
        return Buffer.from(str, 'base64').toString();
    }
    return atob(str);
}
